import { AbstractControl } from '@angular/forms';

export function getError(
  control: AbstractControl,
  errorsDictionary: object,
): string {
  const keys = Object.keys(errorsDictionary);
  const activeError = keys.filter(
    (k) => control && control.errors && !!control.errors[k],
  )[0];
  return (
    errorsDictionary[activeError] ||
    (activeError &&
      control &&
      control.errors &&
      control.errors[activeError].value) ||
    ''
  );
}

export function getErrorWithArgs(
  control: AbstractControl,
  errorsDictionary: object,
  args: Record<string, string | number | boolean>,
): string {
  const keys = Object.keys(errorsDictionary);
  const activeError = keys.filter(
    (k) => control && control.errors && !!control.errors[k],
  )[0];
  return (
    // Checking if passed value is not nullish
    // because *false* should be treated correctly
    ((args[activeError] !== null && args[activeError] !== undefined)
      ? errorsDictionary[activeError](args[activeError])
      : errorsDictionary[activeError]) ||
    (activeError &&
      control &&
      control.errors &&
      control.errors[activeError].value) ||
    'Unspecified error'
  );
}
